import { render, staticRenderFns } from "./ContactMoneyRecurringCharges.vue?vue&type=template&id=0f384677&scoped=true"
import script from "./ContactMoneyRecurringCharges.vue?vue&type=script&lang=js"
export * from "./ContactMoneyRecurringCharges.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyRecurringCharges.vue?vue&type=style&index=0&id=0f384677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f384677",
  null
  
)

export default component.exports